import { postWithAuth, getWithAuth } from '../../../Basic/HttpService';

export const getPenaltyCharges = async (Id) => {
    let res = await getWithAuth(`PenaltyCharges/${Id}`);
    return res;
};

export const getPenaltyChargesScreenDropdowns = async (Id) => {
    console.log('Id', Id);
    let res = await getWithAuth(`PenaltyCharges/screenDropdowns${Id ? `?VehicleID=${Id}` : ''}`);
    return res;
};

export const postPenaltyCharges = async (data) => {
    let res = await postWithAuth(`PenaltyCharges/PenaltyCharges_AddUpdate`, data);
    return res;
};

export const journeyDropDown = async () => {
    let res = await getWithAuth(`Journeys/screenDropdowns`);
    return res;
};

export const DeletePenaltyCharges = async (id) => {
    let res = await postWithAuth(`PenaltyCharges/PenaltyCharges_Delete?Id=${id}`);
    return res;
};

export const getPenaltyChargesNotes_Details = async (ChargeID) => {
    let res = await getWithAuth(`PenaltyCharges/PenaltyChargesNotes_Details?Id=${ChargeID}`);
    return res;
};

export const postPenaltyChargesNotes_AddUpdate = async (data) => {
    let res = await postWithAuth(`PenaltyCharges/PenaltyChargesNotes_AddUpdate`, data);
    return res;
};

export const postPenaltyChargeNote_Delete = async (NoteID) => {
    let res = await postWithAuth(`PenaltyCharges/PenaltyChargeNote_Delete?NoteID=${NoteID}`, {});
    return res;
};
